export default {
    searchTerm: '',
    selectedSite: '',
    apiValoAuth: window.config.use_apivalo_auth,
};



// WEBPACK FOOTER //
// ./src/store/state.js